export default function SelectInput({ value, onChange, disabled, options }) {
  return (
    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="input-secondary"
    >
      <option value="">-- Wybierz odpowiedź --</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
